export interface ValueProps {
  codeStore: string;
  password: string;
}

export interface defaultValue {
  address: string;
  code_shop: string;
  email: string;
  id: number;
  is_change_pass: boolean;
  key_login: string;
  name_shop: string;
  phone: string;
}

export interface ValueAPI {
  status: boolean;
  data: {
    address: string;
    code_shop: string;
    email: string;
    id: number;
    is_change_pass: boolean;
    key_login: string;
    name_shop: string;
    phone: string;
  };
  message: string;
}
export type UserSubmitForm = {
  codeStore: string;
  password: string;
};
export type UserSubmitFormChangePassword = {
  currentpassword: string;
  newpassword: string;
  confirmpassword: string;
};
export type ActivatedSubmitForm = {
  code: string;
  name: string;
  phoneNumber: string;
  email: string;
  address: string;
};
export type SuperVoucherRegisterSubmitForm = {
  code: string;
  name: string;
  gia_tri_sudung: string;
  dv_sudung_kethop: string;
  gia_tri_dv_sudung_kethop: string;
  hinh_hoadon: string;
};
export type ListVoucher = {
  code_voucher: string;
  event: string;
  head_code: string;
  id: number;
  kh_address: string;
  kh_email: string;
  kh_name: string;
  kh_phone: string;
  luckydraw: string;
  time_active: string;
  code: string;
};
export type ListSuperVoucher = {
  code_voucher: string;
  head_code: string;
  id: number;
  kh_name: string;
  gia_tri_sudung: string;
  dv_sudung_kethop: string;
  gia_tri_dv_sudung_kethop: string;
  hinh_hoadon: string;
  time_active: string;
};
export type VoucherParamsType = {
  key: string;
  user_id: number;
  code: string | null;
  type: number;
  kh_name: string;
  kh_phone: string;
  kh_address: string;
  kh_email: string;
};
export type SuperVoucherParamsType = {
  key: string;
  user_id: number;
  code: string | null;
  kh_name: string;
  gia_tri_sudung: string;
  dv_sudung_kethop: string;
  gia_tri_dv_sudung_kethop: string;
  hinh_hoadon: string;
};
export type ParamsType = {
  key: string;
  user_id: number;
  code: string | null;
  type: number;
};
export type PaginationType = {
  limit: number;
  offset: number;
  total: number;
  totalPage: number;
  currentPage: number;
};
export type Pagination = {
  currentPage: number;
  limit: number;
  offset: number;
  total: number;
  totalPage: number;
};
export type ListEvent = {
  id: number;
  date_start: string;
  end_date: string;
  name_event: string;
  status: boolean;
  voucher_active: number;
  count_voucher: number;
};
export type ListEventType = {
  data: Array<ListEvent>;
  status: boolean;
  message: string;
  pagination: Pagination;
};

export const SUPER_VOUCHER = [
  { value: "1", label: "Voucher 100k" },
  {
    value: "2",
    label: "Voucher 50k",
  },
  {
    value: "3",
    label: "Voucher mua xe 300k",
  },
  {
    value: "4",
    label: "Voucher 500k",
  },
];
